import Base from "./Base";

class Views extends Base {
  static getViewData(body) {
    return this.sendRequest("/views/get-view-data", "POST", {}, body);
  }

  static getViews(body) {
    return this.sendRequest("/views/get-views", "POST", {}, body);
  }

  static getView(body) {
    return this.sendRequest("/views/get-view", "POST", {}, body);
  }

  static deleteView(body) {
    return this.sendRequest("/views/delete-view", "POST", {}, body);
  }

  static runView(body) {
    return this.sendRequest("/views/run-view", "POST", {}, body);
  }

  static saveView(body) {
    return this.sendRequest("/views/save-view", "POST", {}, body);
  }

  static saveViewOptions(body) {
    return this.sendRequest("/views/save-view-options", "POST", {}, body);
  }

  static login(body) {
    return this.sendRequest("/login/validate-login", "POST", {}, body);
  }

  static subsheetColumnOrdering(body) {
    return this.sendRequest("/views/change-column-position", "POST", {}, body);
  }
}

export default Views;